/*
  Zeus mobile scroll-rail -- progressive-enhancement prev/next arrows.
  Opt in on any horizontal scroll rail:
    <div data-zeus-rail> ...               (position: relative wrapper)
      {% render 'zeus-scroll-rail-arrows' %}
      <div data-zeus-rail-track> ...cards... </div>
    </div>
  Arrows stay hidden (CSS) until this script adds .is-ready, so they never
  appear as dead buttons when JS is unavailable. Disabled at the scroll ends.
*/
(function () {
  function init(rail) {
    if (rail.classList.contains("is-ready")) return; // re-init guard (shopify:section:load)
    var track = rail.querySelector("[data-zeus-rail-track]");
    var prev = rail.querySelector("[data-zeus-rail-prev]");
    var next = rail.querySelector("[data-zeus-rail-next]");
    if (!track || !prev || !next) return;

    rail.classList.add("is-ready");

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var hasOverflow = max > 0;
      rail.classList.toggle("has-overflow", hasOverflow);
      prev.disabled = !hasOverflow || track.scrollLeft <= 2;
      next.disabled = !hasOverflow || track.scrollLeft >= max;
    }

    function go(dir) {
      var cards = track.querySelectorAll(":scope > *");
      if (!cards.length) return;

      var styles = getComputedStyle(track);
      var anchor =
        track.getBoundingClientRect().left +
        (parseFloat(styles.scrollPaddingInlineStart || styles.paddingInlineStart || styles.paddingLeft) || 0) +
        2;
      var current = 0;

      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getBoundingClientRect().left >= anchor - 1) {
          break;
        }
        current = i;
      }

      var target = Math.max(0, Math.min(cards.length - 1, current + dir));
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      cards[target].scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        inline: "start",
        block: "nearest",
      });
    }

    prev.addEventListener("click", function () {
      go(-1);
    });
    next.addEventListener("click", function () {
      go(1);
    });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function boot() {
    var rails = document.querySelectorAll("[data-zeus-rail]");
    for (var i = 0; i < rails.length; i++) init(rails[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("zeus:rail:refresh", boot);
})();
